import { MUIButton, Title } from '@abb/arcadia-ui-react';
import * as ServiceActionCreators from '@module/license/actionCreators/licenseAllowanceActionCreators';
import * as SiteLicenseActionCreators from '@module/license/actionCreators/siteLicenseActionCreators';
import { AuthorizedUserService } from '@module/authentication/services/authorizedUserService';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '@module/shared/routerCompat';
import * as ActionCreators from '../../actionCreators/hardwareActionCreators';
import { default as CustomerSite } from './CustomerSite';
import { default as ServerTableContainer } from './Hardware/HardwareTableContainer';
import { default as LicenseAllowanceTableContainer } from './LicenseAllowance/LicenseAllowanceTableContainer';
import { default as ServerWithServicesList } from './Machines/MachineList';

/* tslint:disable:no-empty jsx-no-lambda jsx-self-close*/
// TODO: track down anys and type everything
export class SiteLicense extends React.Component<any, any> {
  getDrilldownSiteName = () => {
    const routeSiteName = this.props.location?.state?.siteName;
    const stateSiteName = this.props.servicesState?.site?.siteName;
    return routeSiteName || stateSiteName || '';
  }

  render() {
    const drilldownSiteName = this.getDrilldownSiteName() || 'Loading...';
    let page = (
      <div>
        <h3>Not Authorized</h3>
        <p>{this.props.userPermissions.email} is not an authorized user. Please contact your supervisor to correct this.</p>
      </div>
    );
    if (this.props.userPermissions.allScopes || (this.props.servicesState.site && this.props.userPermissions.scopes.some((s: string) => s === this.props.servicesState.site.country))) {
      page = (
        <div className='container app-content-div' style={{paddingBottom: '40px'}}>
        <div className="with-secondary-text">
          <div className="title-info-container">
            <Title textElement={<div className="title">Sites</div>} />
            <div className="separator-line" />
            <span className="secondary-text">
              {drilldownSiteName}
            </span>
          </div>
        </div>
        <CustomerSite></CustomerSite>
        <LicenseAllowanceTableContainer></LicenseAllowanceTableContainer>
        <ServerTableContainer></ServerTableContainer>
        <ServerWithServicesList></ServerWithServicesList>
        <div className='row bottom-buffer' style={{marginBottom: '40px'}}>
          <div className='download-license-actions'>
            <MUIButton variant='primary' size={32} label='Download ServicePort License File'
              onClickButton={() => this.props.requestLicenseFile(this.props.match.params.siteId)} />
          </div>
        </div>
      </div>);
    }
    return (
      page
    );

  }

  componentDidMount() {
    this.props.refreshUserPermissions();
    this.props.requestServerGet(this.props.match.params.siteId);
    this.props.requestServices(this.props.match.params.siteId);
    this.props.requestServiceTypes(this.props.match.params.siteId);
    this.props.requestOperationalUsagesGet();
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(SiteLicense) as any);

export function mapStateToProps(store: any) {
  const { access_token: accessToken } = store.userState.loggedInUser;
  return { ...store.servicesState, ...store.serverState, ...store.serviceOptionsState, ...store.userState, servicesState: store.servicesState, userPermissions: store.userState.userPermissions, accessToken };
}

function mapDispatchToProps(dispatch: any) {
  return {
    requestServerGet: (siteId: number, accessToken: string) => dispatch(ActionCreators.onServerGetRequest(siteId, accessToken)),
    requestServices: (siteId: number, accessToken: string) => dispatch(ServiceActionCreators.onAllocationGetRequest(siteId, accessToken)),
    requestServiceTypes: (siteId: number, accessToken: string) => dispatch(ServiceActionCreators.onNewAllocationGetRequest(siteId, accessToken)),
    requestOperationalUsagesGet: (accessToken: string) => dispatch(ActionCreators.onOperationalUsagesGetRequest(accessToken)),
    requestLicenseFile: (siteId: number, siteName: string, accessToken: string) => dispatch(SiteLicenseActionCreators.onLicenseFileGetRequest(siteId, siteName, accessToken)),
    refreshUserPermissions: async (loggedInUser: any) => {
      const profile = loggedInUser?.profile || {};
      const email = profile.email || profile.preferred_username || profile.upn || profile.unique_name;
      if (!email) { return; }
      const userPermissions = await AuthorizedUserService.getUserByEmail(email, loggedInUser);
      dispatch({ type: 'USER_LOGIN', loggedInUser, userPermissions });
    }
  };
}

function mergeProps({ accessToken, site, loggedInUser, ...propsFromState }: any, { requestServerGet, requestServices, requestServiceTypes, requestOperationalUsagesGet, requestLicenseFile, refreshUserPermissions, ...propsFromDispatch }: any, ownProps: any) {
  return {
    ...propsFromState,
    ...propsFromDispatch,
    ...ownProps,
    requestServerGet: (siteId: number) => requestServerGet(siteId, accessToken),
    requestServices: (siteId: number) => requestServices(siteId, accessToken),
    requestServiceTypes: (siteId: number) => requestServiceTypes(siteId, accessToken),
    requestOperationalUsagesGet: () => requestOperationalUsagesGet(accessToken),
    requestLicenseFile: (siteId: number, siteName: string) => requestLicenseFile(siteId, site.siteName, accessToken),
    refreshUserPermissions: () => refreshUserPermissions(loggedInUser)
  };
}
